import * as THREE from 'three';

export default class ScreenParticles {

    constructor(config) {

        let defaultConfig = {
            totalParticlesWrap:10000,
            vertDot: '/skins/default/graphics/vert-dot.png'
        };

        this.config = deepmerge(defaultConfig, config);

    }

    doMakeParticles(){

        this.wrapGeom  = new THREE.Geometry();
        this.positions = new Float32Array(this.config.totalParticlesWrap * 3);

        let sizes = new Float32Array(this.config.totalParticlesWrap);
        let opacities = new Float32Array(this.config.totalParticlesWrap);
        let texture = new THREE.TextureLoader().load('/skins/default/graphics/vert-dot.png');

        for (let i = 0; i < this.config.totalParticlesWrap; i++) {
            let vector = new THREE.Vector3(0, 0, 0);
            vector.speedX = (Math.random() - 0.5) * 0.0004;
            vector.speedY = (Math.random() - 0.5) * 0.0004;
            vector.speedZ = (Math.random() - 0.5) * 0.0004;
            vector.applyMatrix4(new THREE.Matrix4().makeTranslation(0, Math.random() * 30000, 0));
            vector.applyMatrix4(new THREE.Matrix4().makeRotationX(Math.random() * (Math.PI * 2)));
            vector.applyMatrix4(new THREE.Matrix4().makeRotationY(Math.random() * (Math.PI * 2)));
            vector.applyMatrix4(new THREE.Matrix4().makeRotationZ(Math.random() * (Math.PI * 2)));

            this.wrapGeom.vertices.push(vector);

            vector.toArray(this.positions, i * 3);
            sizes[i] = Math.random() * 3 + 2;
            opacities[i] = Math.random() * 0.4;
        }

        this.bufferWrapGeom = new THREE.BufferGeometry();
        this.bufferWrapGeom.addAttribute('position', new THREE.BufferAttribute(this.positions, 3));
        this.bufferWrapGeom.addAttribute('size', new THREE.BufferAttribute(sizes, 1));
        this.bufferWrapGeom.addAttribute('opacity', new THREE.BufferAttribute(opacities, 1));

        let wrapMatShader = new THREE.ShaderMaterial({
            uniforms: {
                texture: {
                    value: texture
                }
            },
            vertexShader: document.getElementById("wrapVertexShader").textContent,
            fragmentShader: document.getElementById("wrapFragmentShader").textContent,
            transparent: true
        });

        let wrap = new THREE.Points(this.bufferWrapGeom, wrapMatShader);
        return wrap;
    }

    update() {

        // animate background particles
        for (let i = 0; i < this.config.totalParticlesWrap; i++) {
            let vector = this.wrapGeom.vertices[i];
            vector.applyMatrix4(new THREE.Matrix4().makeRotationX(vector.speedX));
            vector.applyMatrix4(new THREE.Matrix4().makeRotationY(vector.speedY));
            vector.applyMatrix4(new THREE.Matrix4().makeRotationZ(vector.speedZ));
            vector.toArray(this.positions, i * 3);
        }
        this.bufferWrapGeom.addAttribute('position', new THREE.BufferAttribute(this.positions, 3));

    }


    
}




